<template>
  <div class="forms display">
    <div class="mid">
      <div style="display: flex;">
        <a-col class="flex">
          <label>当前负责人：</label>
          <a-select style="min-width: 100px;" v-model="form.user_id" placeholder="请选择" class="nselect" show-search
            allowClear option-filter-prop="children" :filter-option="filterOption">
            <a-select-option v-for="i in userList" :key="i.id">{{ i.uname }}</a-select-option>
          </a-select>
        </a-col>
        <a-col class="flex">
          <label>原告：</label>
          <a-select v-model="form.accuser_ids" placeholder="请选择" mode="multiple" :maxTagCount='1' :maxTagTextLength='6'
            allowClear class="select" option-filter-prop="children" :filter-option="filterOption" style="width:240px;">
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id" :title='item.title'>{{
              item.title }}
              <!-- <a-tooltip overlayClassName="custom-tip">
                <template slot="title">
                  <span>{{ item.title }}</span>
                </template>
<span>{{ item.title }}</span>
</a-tooltip> -->
            </a-select-option>
          </a-select>
        </a-col>
        <a-col class="flex">
          <label>进度：</label>
          <a-select v-model="form.step" placeholder="请选择" allowClear class="select" style="width:202px;" mode="multiple"
            :maxTagCount='1' :maxTagTextLength='4' @change="selectStep">
            <a-select-option v-for="(item, key) in LiteKey" :key="item" :value="key">{{ item }}</a-select-option>
          </a-select>
        </a-col>
      </div>
      <div class="find">
        <a-button icon="search" @click="resh">查询</a-button>
        <a-button @click="reset">重置</a-button>
        <!-- <a-button type="primary" icon="plus" @click='edit=1;disType=2;visible=true;'>新增</a-button> -->
      </div>
    </div>
    <div class="table">
      <Table :getUrl='putData.url[0]' :formKey='putData.formKey' :query='q' ID='debtor_id' ref='table'>
        <template v-slot:pick='v'>
          <span v-if='$common.AUTH("debtor:info")'>
            <router-link :to='{ "name": "lydetails", params: { "id": v.id } }' class="curpoter" target="_blank"
              style='color: #1d8bfe;'> 查看</router-link>
          </span>
          <span v-else>
            查看
          </span>
        </template>
      </Table>
      <!-- <div class="nqx smnq" v-else>您没有该页面的访问权限，请联系管理员开通。</div> -->
    </div>
  </div>
</template>
<script>
import Table from './table.vue'
import { getAccuserAll } from '@/server/api'
import { accUserList } from '@/server/user'
import LiteKey from '@/page/ly/liteKey.json'
const uniqueLiteKey = {}
const nameSet = new Set()

// 遍历原始对象
Object.entries(LiteKey).forEach(([key, value]) => {
  // 如果名称没出现过，就保留
  if (!nameSet.has(value)) {
    nameSet.add(value)
    uniqueLiteKey[key] = value
  }
})
export default {
  name: 'Over',
  props: {
    putData: Object
  },
  data() {
    return {
      LiteKey: uniqueLiteKey,
      accuserList: [],
      userList: [],
      form: {
        user_id: undefined,
        step: [],
        accuser_ids: []
      },
      Steps: []
    }
  },
  components: { Table },
  computed: {
    q() {
      return { user_id: this.form.user_id, step: this.form.step.toString(), accuser_ids: this.form.accuser_ids.toString() }
    }
  },
  created() {
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
    accUserList(this.$store.state.user.id > 1 ? { title: this.$store.state.user.title, is_inner: 1 } : { is_inner: 1 }).then((res) => {
      this.userList = res.list
    })
  },
  methods: {
    selectStep(selectedValues) {
      // 定义自动追加的规则
      const rules = {
        '170': ['170', '171', '172', '173', '174', '175', '176', '177', '178', '179'],
        '21': ['21', '22', '23', '24'],
        '161': ['161', '162', '163', '164', '165', '166', '167', '168', '169'],
        '185': ['185', '186', '187', '188', '189'],
        '191': ['191', '192', '193', '194', '195', '196', '197', '198', '199']
      }

      // 收集所有需要追加的值
      let addValues = []
      for (const key in rules) {
        if (selectedValues.includes(key)) {
          addValues = [...addValues, ...rules[key]]
        }
      }

      // 合并 + 去重 + 赋值
      this.Steps = Array.from(new Set([...selectedValues, ...addValues]))
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    resh() {
      this.form.step = this.Steps
      setTimeout(e => {
        this.$refs.table.resh()
      }, 200)
    },
    reset() {
      this.form.user_id = undefined
      this.form.accuser_ids = []
      this.form.step = []
      this.resh()
    }
  }
}
</script>
<style lang="less" scoped>
.mid {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .flex {
    display: flex;
    align-items: center;
    margin-right: 10px;

    label {
      white-space: nowrap;
    }
  }

  .find {
    display: flex;
    align-items: center;

    /deep/.input {
      width: 132px;
      height: 30px;

      input {
        padding: 4px 8px;
        height: 30px;
        font-size: 13px;
        line-height: 30px;
      }
    }

    /deep/.ant-btn {
      height: 30px;
      margin-left: 15px;
    }
  }
}
</style>
<style>
.custom-tip .ant-tooltip-inner {
  background-color: #ffffff !important;
  color: #000 !important;
}

.custom-tip [class*='ant-tooltip-arrow']::before {
  background: #ffffff !important;
  border-color: #ffffff !important;
}
</style>